import {
  Video, Keyboard, ScanLine, Cylinder, Martini, TrendingUp, FileText, Upload,
  Package, Receipt, CalendarDays, ShoppingCart, Truck, CloudSun, Sparkles, ClipboardCheck,
  PoundSterling, BarChart3, List, Bell, Mail, Download, Users, Undo2, LifeBuoy,
  ShieldCheck,
} from "lucide-react";

export const ICONS = {
  video: Video, keyboard: Keyboard, scan: ScanLine, barrel: Cylinder,
  cocktail: Martini, trend: TrendingUp, file: FileText, upload: Upload,
  box: Package, receipt: Receipt, calendar: CalendarDays, cart: ShoppingCart, truck: Truck,
  cloud: CloudSun, sparkle: Sparkles, check: ClipboardCheck, pound: PoundSterling,
  chart: BarChart3, list: List, bell: Bell, mail: Mail, download: Download,
  users: Users, undo: Undo2, help: LifeBuoy, shield: ShieldCheck,
};

export function Icon({ name, size = 20 }) {
  const C = ICONS[name];
  return C ? <C size={size} strokeWidth={2} aria-hidden="true" /> : null;
}
